<div class="panel-container" id="shareScreen" #shareScreen [ngClass]="{'no-margin': !shareCanvas, hiddenForced : interactionMode}"></div>
<div class="panel-container" id="zoomRoot" #zoomRoot></div>

